import React, { useState } from "react";
import ReactDOM from "react-dom";
import { IntegrationModal } from './Modals/IntegrationModal';
import { ModalBase, ModalMessage } from "../styles/refreshModal";
import "../styles/refreshModal.css";
import ExitIcon from '../images/exitIcon.png';
import WarningIcon from "../images/warning.png";

const RefreshModal = () => {
  const [isModalOpen, setModalOpen] = useState(true);

  const refreshWindow = () => {
    window.location.reload();
  };
  const onClickCancel = () => {
    setModalOpen(false);
  }

  return (
    isModalOpen && (
      <IntegrationModal
        className="confirm-refresh h-admin-refresh"
        title={"Something went wrong"}
        message={<ModalMessage>Please try refreshing this page.<br/> Contact <span>support@hiverhq.com</span> if you continue to face this issue.</ModalMessage>}
        modalStyle={ModalBase}
        leftButtonProps={{
          value: "Cancel",
        }}
        rightButtonProps={{
          value: "Refresh",
        }}
        onClickRight={refreshWindow}
        onClickLeft={onClickCancel}
        isOpen={true}
        exitIcon={ExitIcon}
        modalType={WarningIcon}
      />
    )
  );
};
const refreshModalConsumer = () => {
  const appRoot = document.querySelector("#root");
  ReactDOM.render(<RefreshModal />, appRoot);
};

export default refreshModalConsumer;
